import {Container, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {api} from "../../services/apiService";

import ProductOrOptionForm from "../../components/ProductOrOptionForm";


export default function ProductEdit() {
    const params = useParams();
    const navigate = useNavigate();
    // Récupération de l'ID du produit à modifier depuis l'URL
    const productId = params.id;
    const [initialValues, setInitialValues] = useState(null);

    useEffect(() => {
        api.get(`/products/${productId}`)
            .then(response => {
                setInitialValues(response.data);
            })
            .catch(error => {
                console.error("Error fetching product data:", error);
                navigate("/products"); // Redirige vers la liste des produits en cas d'erreur
            });
    }, [productId, navigate]);

    const handleSubmit = (formData) => {
        const request = api.put(`/products/edit/${productId}`, formData)
            .then(() => {
                navigate("/products");
            })
            .catch(error => {
                console.error("Error updating product:", error);
            });

        return request;
    };

    return (
        <Container>
            <Typography variant="h1" gutterBottom>Modifier un produit</Typography>

            <ProductOrOptionForm onSubmit={handleSubmit} data={initialValues} editionMode={true}/>
        </Container>
    );
}
